import { styled } from '@nykaa/ui-components';

export const ViewSimilarButton = styled.button`
  height: 32px;
  width: 32px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
